module.exports = __webpack_public_path__ + "img/runner.fdafffed.png";